import React from "react";
import { Route, Switch } from "react-router-dom";

import ContactInfo from "../ContactInfo";
import Address from "../Address";
import HunterPermit from "../HunterPermit";
import ID from "../ID";
import Questionnaire from "../Questionnaire";
import RangeRental from "../RangeRental";
import MinorsInParty from "../Minors/MinorsInParty";
import MinorInfo from "../Minors/MinorInfo";
import MinorAddress from "../Minors/MinorAddress";
import MinorQuestionnaire from "../Minors/MinorQuestionnaire";
import MinorList from "../Minors/MinorList";
import Agreement from "../Agreement";
import RangeRules from "../RangeRules";
import Complete from "../Complete/Complete";
import Signature from "../Signature";

import RegistrationNavigator
  from "../RegistrationNavigator/RegistrationNavigator";

const NavigatorLayout = ({
  currentRegistration,
  currentRegistrationId,
  updateRegistration
}) => (
  <div className="registration-wizard md-cell--12 md-grid">
    <div className="md-cell md-cell--8">
      <Switch>
        <Route exact path={"/registration/signature"} component={Signature} />

        <Route
          exact
          path={"/registration/contact-info"}
          component={ContactInfo}
        />
        <Route exact path={"/registration/address"} component={Address} />
        <Route
          exact
          path={"/registration/hunter-permit"}
          component={HunterPermit}
        />
        <Route exact path={"/registration/id"} component={ID} />
        <Route
          exact
          path={"/registration/questionnaire/:index?"}
          component={Questionnaire}
        />
        <Route
          exact
          path={"/registration/range-rental"}
          component={RangeRental}
        />
        <Route exact path={"/registration/minors"} component={MinorsInParty} />
        <Route exact path={"/registration/minors/list"} component={MinorList} />
        <Route
          exact
          path={"/registration/minors/:index/contact-info"}
          component={MinorInfo}
        />
        <Route
          exact
          path={"/registration/minors/:index/address"}
          component={MinorAddress}
        />
        <Route
          exact
          path={"/registration/minors/:index/questionnaire/:questionIndex"}
          component={MinorQuestionnaire}
        />
        <Route exact path={"/registration/signature"} component={Signature} />
        <Route
          exact
          path={"/registration/range-rules"}
          component={RangeRules}
        />
        <Route exact path={"/registration/agreement"} component={Agreement} />
        <Route exact path={"/registration/complete"} component={Complete} />
      </Switch>
    </div>
    <div className="md-cell md-cell--4">
      <RegistrationNavigator
        currentRegistration={currentRegistration}
        onClick={data => updateRegistration(currentRegistrationId, data)}
      />
    </div>
  </div>
);

export default NavigatorLayout;



// WEBPACK FOOTER //
// ./src/registration/components/Navigator/NavigatorLayout.jsx